import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Row, Table } from "reactstrap";

import { useNavigate } from "react-router-dom";
import { BiEditAlt, BiTrash } from "react-icons/bi";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { BiLeftArrowAlt } from "react-icons/bi";
import useAuth from '../../hooks/useAuth';
import { TestimonialPaginationTable } from "../../components/PaginationC/TestimonialPaginationTable";

const TestimonialView = () => {
  const { auth } = useAuth();

  const [modal, openModal] = useState(false);
  const toggle = () => openModal(!modal);
  const [testimonial, setTestimonial] = useState([]);
  const navigate = useNavigate();

  // const {testimonial} = useContext(ContactContext);
  const handleDelete = async (event, id) => {
    event.preventDefault();
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/testimonials/delete-testimonial/${id}`,
        {
          headers: {
            Authorization:
              "Bearer " + auth.accessToken,
          },
        }
      );
      const res1 = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/testimonials/find-all`
      );
      setTestimonial(res1.data);
      toast.success(res.data.message, {
        className: "success-toast",
        autoClose: 3000,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      error.response.data.message
        ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          })
        : toast.error(error.response.data.error, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          });
    }
  };

  useEffect(() => {
    const source = axios.CancelToken.source();
    const gettestimonial = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/testimonials/find-all`,
          {
            cancelToken: source.token,
          }
        );
        setTestimonial(res.data);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }
    };

    gettestimonial();
    return () => {
      source.cancel();
    };
  }, []);
  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Testimonial List</h5>
      </Row>
      <Row>
        <TestimonialPaginationTable data={testimonial} deleteAction={handleDelete} />
        {/* <Table responsive hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Description</th>
              <th>Author Name</th>
              <th>Author Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {testimonial.map((testimonial) => (
              <tr key={testimonial.id}>
                <td>{testimonial.id}</td>
                <td style={{ wordBreak: "break-all" }}>{testimonial.testimonialTitle}</td>
                <td style={{ wordBreak: "break-all" }}>{testimonial.testimonialDesc}</td>
                <td>{testimonial.authorName}</td>
                <td>
                  <img
                    style={{ width: 120 }}
                    src={
                      process.env.REACT_APP_API_IMAGE_URI.substring(
                        0,
                        process.env.REACT_APP_API_IMAGE_URI.indexOf("/api")
                      ) +
                      `${testimonial.authorImg.substring(
                        testimonial.authorImg.indexOf("/uploads")
                      )}`
                    }
                    alt={testimonial.authorName}
                  ></img>
                </td>
                <td>
                  <BiEditAlt
                    className="edit_icon icon_hover"
                    onClick={() => navigate(`/testimonials/edit/${testimonial.id}`)}
                    size={20}
                  />
                  <BiTrash
                    className="delete_icon icon_hover"
                    onClick={(event) => handleDelete(event, testimonial.id)}
                    size={20}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table> */}
      </Row>
      {/* {testimonial && (
        <Row sm="12" className="mt-4 text-center">
          <Link to={"/testimonials/add"} className="go_back">
            <BiLeftArrowAlt size={30} /> Go to Add testimonial
          </Link>
        </Row>
      )} */}
    </div>
  );
};

export default TestimonialView;
